import { render } from "./liuhepankou.vue?vue&type=template&id=ee1c15cc&scoped=true"
import script from "./liuhepankou.vue?vue&type=script&lang=js"
export * from "./liuhepankou.vue?vue&type=script&lang=js"

import "./liuhepankou.vue?vue&type=style&index=0&id=ee1c15cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee1c15cc"]])

export default __exports__